// extracted by mini-css-extract-plugin
module.exports = {"componentsPhoneItem":"styles_componentsPhoneItem__2a-bz"};